<template>
  <div id="account" class="mb-6 text-NotoSansRegular textColorDarkBlack">
    <div class="max-w-2xl mx-auto">
      <h3 class="text-base lg:text-lg pb-1 border-b md:border-b-0 md:text-center mb-8 pt-3 px-2">
        帳號管理
      </h3>

      <form class="w-full px-2 mb-8" v-if="userData">
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="email">
              會員帳號
            </label>
          </div>
          <div class="md:w-3/4">
            <input readonly class="text-sm appearance-none border-0 rounded w-full py-3 px-4 leading-tight focus:outline-none"
              id="account" type="text" :value="$store.state.auth.user.email">
          </div>
        </div>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="name">
              會員姓名
            </label>
          </div>
          <div class="md:w-3/4">
            <input class="text-sm appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="name" type="text" v-model="userData.name" maxlength="20">
          </div>
        </div>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="subscriber-name">
              會員生日
            </label>
          </div>
          <div class="md:w-3/4">
            <date-picker :input-class="'py-3 w-full focus:outline-none text-sm text-NotoSansRegular'" v-model="userData.birth" valueType="format" type="date" :disabled-date="disabledDate"></date-picker>
          </div>
        </div>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="company-phone">
              手機號碼
            </label>
          </div>
          <div class="md:w-3/4 flex">
            <div class="w-1/3 relative">
              <select v-model="userData.country_code" class="block appearance-none w-full text-sm border border-gray-500 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="invoice"
                >
                <option :value="item.phoneCode" v-for="(item, index) in countryCode" :key="index">{{ item.countryName }}({{ item.phoneCode }})</option>
              </select>
              <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
            <input class="text-sm appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="company-phone" type="text" value="" v-model="userData.mobile" placeholder="ex: 0900123456" maxlength="10">
          </div>
        </div>
        <!-- <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="company-tel">
              住家電話
            </label>
          </div>
          <div class="md:w-3/4">
            <input class="text-sm appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="company-tel" type="text" value="" v-model="userData.tel" placeholder="ex: 02-21234567">
          </div>
        </div> -->
        <div class="md:flex md:items-center mb-2">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="address">
              聯絡地址
            </label>
          </div>
            <div class="md:w-3/4">
              <Address
                v-on:getAddress="getAddress"
                :userCity="userData.city"
                :userDistrict="userData.district"
              />
            </div>
        </div>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4 hidden md:block">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4 opacity-0" for="lastAddress">
              聯絡地址
            </label>
          </div>
          <div class="md:w-3/4">
            <input v-model="userData.address" class="text-sm appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="lastAddress" type="text" value="" name="address">
          </div>
        </div>

        <div class="md:flex md:items-center mb-4" v-if="donationList">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="donationList">
              受贈機關或團體
            </label>
          </div>
          <div class="md:w-3/4 relative text-sm">
            <VueSelectComponent
            :optionData="donationList"
            :userDonation="userData.invoice_donation"
            v-on:inputLoveCode="inputLoveCode"
            :clearable="false"
            class="donat-selector border rounded border-gray-500 py-3 px-2" />
          </div>
        </div>

        <div class="flex items-center mb-8">
          <div class="w-full flex md:justify-end px-1 md:px-2">
            <button @click="editProfile" class="cursor-pointer button-red text-white py-2 px-12 rounded w-full md:w-auto" type="button">
              更新資料
            </button>
          </div>

        </div>
      </form>

      <form class="w-full px-2">
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="newPwd">
              新密碼
            </label>
          </div>
          <div class="md:w-3/4">
            <input class=" appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900 text-sm"
              id="newPwd" type="password" v-model="password" autocomplete="old-passwor" maxlength="15" placeholder="請輸入8碼至15碼英數字">
          </div>
        </div>
        <div class="md:flex md:items-center mb-4">
          <div class="md:w-1/4">
            <label class="block text-gray-900 text-sm lg:text-base mb-1 md:mb-0 pr-4" for="passwordCheck">
              確認新密碼
            </label>
          </div>
          <div class="md:w-3/4">
            <input class=" appearance-none border border-gray-500 rounded w-full py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900 text-sm"
              id="passwordCheck" type="password" v-model="passwordCheck" autocomplete="check-password" maxlength="15" placeholder="再次輸入密碼">
          </div>
        </div>
        <div class="flex items-center mb-8">
          <div class="w-full flex md:justify-end px-1 md:px-2">
            <button class="cursor-pointer button-red text-white py-2 px-12 rounded w-full md:w-auto"
              type="button" @click="editPwd">變更密碼
            </button>
          </div>

        </div>
      </form>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Address from '@/components/modules/AddressSection.vue'
import Regex from '@/components/modules/regex'
import VueSelectComponent from '@/components/checkout/VueSelect'
import sweetAlert from '@/components/modules/sweetAlert'
import countryCode from '@/components/modules/countryCode.json'
export default {
  name: 'Account',
  data () {
    return {
      countryCode: countryCode,
      userData: null,
      oldPassword: null,
      password: null,
      passwordCheck: null,
      disabledDate (date) {
        return date > new Date()
      },
      // 電子發票捐贈
      donationList: null
    }
  },
  components: {
    DatePicker,
    Address,
    VueSelectComponent
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  computed: {
    ...mapGetters([
      'authorized',
      'userRole',
      'user'
    ])
  },
  mounted () {
    this.setData()
    this.getLoveCode()
  },
  methods: {
    getLoveCode () {
      axios.get('/cart/lovecode/list')
        .then((response) => {
          this.donationList = response.data
          console.log(response.data)
        })
    },

    setData () {
      if (!this.user) return
      this.userData = {
        ...this.user,
        country_code: (this.user && this.user.country_code) ? this.user.country_code : '+886'
      }
      this.userData.invoice_donation = this.user.invoice_donation && typeof this.user.invoice_donation === 'string' ? this.user.invoice_donation : ''
      let index = this.countryCode.findIndex(x => x.phoneCode === this.userData.country_code)
      this.userData.country = this.countryCode[index].countryName
    },

    getAddress (getAddress) {
      this.userData.city = getAddress.city
      this.userData.district = getAddress.district
      this.userData.zip_code = getAddress.zip_code
    },

    async editProfile () {
      if (this.userData.mobile && this.userData.birth && this.userData.name && this.userData.city && this.userData.district && this.userData.address) {
        // 基本資料

        let profData = {
          ...this.userData
        }
        await axios.patch('/user/me', profData)
          .then(() => {
            this.isSuccess = true
            this.$store.dispatch('getProfile')
            this.alertPop('success', '更新成功')
          })
          .catch(() => {
            this.isSuccess = false
          })
      } else {
        this.alertPop('warning', '欄位空白或格式錯誤')
      }
    },

    async editPwd () {
      if (this.checkPwdEqual(this.password, this.passwordCheck) && this.rexPassword(this.password)) {
        let data = {
          password: this.password
        }
        axios.patch('/user/me', data)
          .then((response) => {
            this.$store.dispatch('getProfile')
            this.alertPop('success', '密碼修改成功')
          })
          .catch(() => {
            this.alertPop('warning', '系統錯誤')
          })
      } else if (!this.checkPwdEqual(this.password, this.passwordCheck)) {
        this.alertPop('warning', '密碼不一致')
      } else if (!this.rexPassword(this.password)) {
        this.alertPop('warning', '請輸入8碼至15碼英數字')
      }
    },

    inputLoveCode (inputLoveCode) {
      this.userData.invoice_donation = inputLoveCode
    }
  }
}
</script>

<style lang="scss">
  .donat-selector .vs__clear {
    display: none;
  }
  #account {
    .mx-datepicker {
      width: 100% !important;
      border-width: 1px !important;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
      border-color: #a0aec0 !important;
    }
  }
  </style>
